import { Table } from '@statsbomb/kitbag-components';
import { useSetAtom } from 'jotai';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { technicalMetadataWarningsAtom } from '../../atoms/approval';
import MetadataValue from './MetadataValue';

const WARNINGS = 'warnings';

export function TechnicalMetadataViewSingle({ metadata }) {
  const setWarnings = useSetAtom(technicalMetadataWarningsAtom);

  useEffect(() => {
    setWarnings(metadata?.warnings || []);
  }, [metadata]);

  return (
    <Table>
      <Table.Head>
        <Table.HeaderCell colSpan={2}>
          <FormattedMessage defaultMessage="Technical Metadata" id="c0448" />
        </Table.HeaderCell>
      </Table.Head>
      {metadata &&
        Object.keys(metadata).map(
          (dataTypeIdentifier) =>
            dataTypeIdentifier !== WARNINGS && (
              <MetadataValue
                key={dataTypeIdentifier}
                dataTypeIdentifier={dataTypeIdentifier}
                value={metadata[dataTypeIdentifier]}
              />
            ),
        )}
    </Table>
  );
}

TechnicalMetadataViewSingle.propTypes = {
  metadata: PropTypes.shape().isRequired,
};

export default { TechnicalMetadataViewSingle };
